import React, { useEffect, useState } from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';
import { VERTICALS } from '../../../../constants/app-constant';
import { groupBy } from '../../../../utility/common-methods';
import { NoFeedIcon, SocialForumIcon, SocialBlogIcon, BlogIcon } from '../../../Icons/icons.component';
import Loader from '../../../Shared/Loader';
import FavouriteFeedItem from './FavouriteFeedItem';
const FavouriteFeedsList = ({
  favouritesList = [],
  selectedDropdownValue,
  clientId,
  feedsLoader,
  paginationData,
  socialViewMoreClick,
  blogForumViewMoreClick,
  currentActiveVerticalAccordian,
}) => {
  const { V_SOCIAL, V_BLOG, V_FORUM } = VERTICALS;
  const SOCIAL = "SOCIAL";
  const BLOGS = "BLOGS";
  const FORUM = "FORUM";
  const socialIdentifier = `identifier-${currentActiveVerticalAccordian == V_BLOG ? 0 : 1}`;

  const [activeKey, setActiveKey] = useState(-1);

  useEffect(() => {
    setActiveKey(socialIdentifier);
  }, [favouritesList]);

  const getNameOfFeedEntity = (key, name = "") => {
    switch (parseInt(key)) {
      case V_SOCIAL:
        name = SOCIAL;
        break;
      case V_BLOG:
        name = BLOGS;
        break;
      case V_FORUM:
        name = FORUM;
        break;
      default:
        name = "SOCIAL";
        break;
    }
    return name;
  };

  const handleCardClick = (e, id) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (id === activeKey) {
      setActiveKey(-1);
    } else {
      setActiveKey(id);
      handleOnAccordianClick(id);
    }
  };

  const handleOnAccordianClick = (id, index) => {
    setActiveKey(activeKey == id ? null : id);
    const targetElm = document.getElementById(id);
    const scrollElement = document.querySelector(".accordionListWrap");
    if (targetElm && scrollElement) {
      const position = targetElm.getBoundingClientRect().top || 0;
      setTimeout(() => {
        scrollElement.scrollTo({
          top: position - (120 - 20 * index),
          behavior: "smooth",
        });
      }, 1000);
    }
  };

  const renderFeedsListing = () => {
    const data = groupBy(favouritesList, "type");
    return Object.keys(data).map((key, index) => {
      const identifier = `identifier-${index}`;
      const isActive = activeKey === identifier;
      const activeClass = key == V_SOCIAL ? "show" : isActive ? "show" : "";
      const currentVerticalKey = data[key];
      const showViewMoreForCurrentVertical =
        currentVerticalKey.length < currentVerticalKey[currentVerticalKey.length - 1].totalFeeds;
      return (
        <div
          className={
            activeKey !== identifier
              ? "customAccordionRow card"
              : "customAccordionRow card active"
          }
        >
          <div className={`card-header ${activeClass}`}>
            <div
              onClick={(e) => {
                handleCardClick(e, identifier);
              }}
              id={identifier}
              type="button"
              className="btn btn-link"
            >
              <ButtonGroup className="smallToggleBtnGroup">
                {key == V_SOCIAL && (
                  <>
                    <Button className="tagBlue active">
                      <SocialBlogIcon />
                      Social
                    </Button>
                  </>
                )}
                {key == V_BLOG && (
                  <>
                    <Button className="tagViolet active">
                      <BlogIcon />
                      Blogs
                    </Button>
                  </>
                )}
                {key == V_FORUM && (
                  <>
                    <Button className="tagBrown active">
                      <SocialForumIcon />
                      Forum
                    </Button>
                  </>
                )}
              </ButtonGroup>
            </div>
          </div>
          <div className={`collapse ${activeClass}`}>
            <div className="card-body">
              <div className="inner-feed-container">
                {data[key] &&
                  data[key].map((feed, index) => {
                    if (!feed) {
                      return null;
                    }
                    return (
                      <FavouriteFeedItem
                        vertical={key}
                        key={index}
                        {...feed}
                        isModal={true}
                        clientId={clientId}
                      />
                    );
                  })}

                {key == V_SOCIAL && data[key].length < paginationData.total ? (
                  <div className="viewMoreBtnWrap">
                    {feedsLoader ? (
                      <Loader />
                    ) : (
                      <Button
                        className="btn btnBlue viewMoreBtn"
                        onClick={() => socialViewMoreClick()}
                      >
                        View More
                      </Button>
                    )}
                  </div>
                ) : null}
                {(key == V_BLOG && showViewMoreForCurrentVertical) ||
                  (key == V_FORUM && showViewMoreForCurrentVertical) ? (
                  <div className="viewMoreBtnWrap">
                    {feedsLoader ? (
                      <Loader />
                    ) : (
                      <Button
                        className="btn btnBlue viewMoreBtn"
                        onClick={() => {
                          const { page, type } = data[key][data[key].length - 1];
                          blogForumViewMoreClick(page + 1, type);
                        }}
                      >
                        View More
                      </Button>
                    )}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <>
      {
        favouritesList.length == 0 ?
          <div className="noFilterDataWrap">
            <NoFeedIcon />
            <h6>No Feeds Found</h6>
            <p>Please favourite some feeds</p>
          </div>
          :
          <div
            className={
              selectedDropdownValue == V_SOCIAL || selectedDropdownValue == V_BLOG
                ? "accordion accordionListWrap socialAccordionWrap favFeedsAccordionWrap favSocialFeeds"
                : "accordion accordionListWrap socialAccordionWrap favFeedsAccordionWrap"
            }
          >
            {renderFeedsListing()}
          </div>
      }
    </>
  )
};

export default FavouriteFeedsList;
